const mui = {
  MuiRadio: {
    defaultProps: {
      size: "small",
      color: "primary",
    },
    styleOverrides: {
      root: {
        "&:hover": {
          backgroundColor: "transparent",
        },
      },
    },
  },
};
export default mui;
